/** The viewer's version and page; the server still admits only a proposal's own versions and files. */
export interface DesignProposalSearch { commit?: string; page?: string }

export function designProposalSearch(search: Record<string, unknown>): DesignProposalSearch {
  const commit = search['commit'], page = search['page']
  return {
    ...(typeof commit === 'string' && /^[0-9a-f]{40}$/.test(commit) ? { commit } : {}),
    ...(typeof page === 'string' && page.length <= 1024 ? { page } : {}),
  }
}
